import styled from 'styled-components';
export var ActiveFiltersDescription = styled.div.withConfig({
  displayName: "ActiveFiltersDescription",
  componentId: "sc-1rfz511-0"
})(["margin-top:8px;margin-bottom:24px;"]);